<template>
  <div class="list-item" style="min-height: 30px">
    <div @click="change" class="header-pay">
      <div>
        <img
          :src="getImgCheck"
          alt=""
          class="list-item-check"
          @click="changeCheck"
          @click.stop.prevent
          v-if="canOption"
        />

        <img
          src="../../../assets/pay/item-title.png"
          alt=""
          class="list-item-title"
        />
        <strong>{{ dataInfo.areaName }}-{{ dataInfo.houseName }}</strong>
      </div>
      <img :src="getImgInfo" alt="" />
    </div>

    <div v-if="isShowInfo" class="main">
      <info-item
        :can-option="canOption"
        v-for="data in dataInfo.bills"
        :key="data.id"
        :total-units="dataInfo.totalUnits"
        :data-info="data"
      >
      </info-item>
    </div>
  </div>
</template>

<script>
import InfoItem from "./InfoItem";

export default {
  name: "ListItem",

  components: {
    InfoItem
  },

  created() {
    if (this.firstOrgId === this.dataInfo.id) {
      this.isShowInfo = true;
    }

    this.dataInfo.bills.forEach(item => {
      this.billIdList.add(item.id);
    });
  },

  props: {
    firstOrgId: String,
    dataInfo: {},
    canOption: Boolean
  },

  data() {
    return {
      isShowInfo: false,
      isSelect: false,
      billIdList: new Set(),
      billIdSelectList: new Set()
    };
  },

  computed: {
    getImgInfo() {
      if (this.isShowInfo) {
        return require("../../../assets/key/down.png");
      } else {
        return require("../../../assets/key/next.png");
      }
    },

    getImgCheck() {
      if (this.isSelect) {
        return require("../../../assets/pay/check-item-yes.png");
      } else {
        return require("../../../assets/pay/check-item-no.png");
      }
    }
  },

  methods: {
    change() {
      this.isShowInfo = !this.isShowInfo;
    },

    changeCheck() {
      this.isShowInfo = true;

      setTimeout(() => {
        this.isSelect = !this.isSelect;
        if (this.isSelect) {
          this.addAll(this.billIdList);
        } else {
          this.clearAll(this.billIdList);
        }
      }, 10);
    },

    addAll(array) {
      array.forEach(value => {
        this.$parent.billIdList.add(value);
      });
      this.$parent.excite();
      this.$children.forEach(value => {
        value.isSelect = true;
      });
    },

    clearAll(array) {
      array.forEach(value => {
        this.$parent.billIdList.delete(value);
      });
      this.$parent.excite();
      this.$children.forEach(value => {
        value.isSelect = false;
      });
    },

    selectItem(id) {
      this.billIdSelectList.add(id);
      this.isSelect = this.billIdSelectList.size === this.billIdList.size;
      this.$parent.billIdList.add(id);
      this.$parent.excite();
    },

    deleteItem(id) {
      this.billIdSelectList.delete(id);
      this.isSelect = this.billIdSelectList.size === this.billIdList.size;
      this.$parent.billIdList.delete(id);
      this.$parent.excite();
    }
  }
};
</script>

<style scoped lang="scss">

.list-item {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 10px;
  .header-pay {
    padding: 0 14px;
    box-sizing: border-box;
    border-radius: 10px;
    height: 44px;
    color: white;
    background: #1296db;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .list-item-check {
      width: 20px;
    }
    .list-item-title {
      width: 26px;
    }
    img {
      width: 22px;
    }
    div {
      align-items: center;
      display: flex;
      * {
        margin-right: 8px;
      }
    }
  }
}
</style>
